import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'event_list_table.cells.top_match_face';

export const useTopMatchFaceCellTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => {
  return useTranslation('entities', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'Не найдено лицо из совпадения',
    tooltip_empty_card: 'В базе данных не найдено совпадение с детерминированным объектом',
    no_data: 'Нет данных',
    tag_face: 'Лицо',
    external_id: 'Внешний ID',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'No face found from the match',
    tooltip_empty_card: 'No match for the deterministic object was found in the database',
    no_data: 'No data',
    tag_face: 'Face',
    external_id: 'External ID',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'No se encontró ningún rostro en la coincidencia',
    tooltip_empty_card: 'No se encontró ninguna coincidencia para el objeto determinista en la base de datos',
    no_data: 'Sin datos',
    tag_face: 'Rostro',
    external_id: 'ID externo',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    tooltip_empty_sample: 'Nenhuma identificação facial encontrada na correspondência',
    tooltip_empty_card: 'Não foi encontrada nenhuma correspondência para o objeto determinístico no banco de dados',
    no_data: 'Sem dados',
    tag_face: 'Face',
    external_id: 'ID externo',
  },
}) as Record<string, unknown>;
